export default __webpack_public_path__ + "static/media/video_classification_after.e81bb731.mp4";